import { MARKER_HEIGHT, MARKER_WIDTH } from "components/Map/constants/icons";
import { getFuelIcon, getStopTruckIcon, getUntrackIcon } from "./icons";

import { svgToDataURL } from "common/utils/index";
import { NavigationHistoryPathType } from "entities/navigation";

export const getStationIcon = () => {
  return {
    url: svgToDataURL(getFuelIcon()),
    width: MARKER_WIDTH,
    height: MARKER_HEIGHT,
  };
};

export const getHistoryEventIcon = (type: NavigationHistoryPathType) => {
  if (type === "Parking") {
    return {
      url: svgToDataURL(getStopTruckIcon()),
      width: MARKER_WIDTH / 2,
      height: MARKER_HEIGHT / 2,
    };
  }

  if (type === "Untracked") {
    return {
      url: svgToDataURL(getUntrackIcon()),
      width: MARKER_WIDTH / 2,
      height: MARKER_HEIGHT / 2,
    };
  }

  return null;
};
